import React from 'react';

import { TaskInventory } from '@bringg/types';
import { RoutesPlannerTask } from '@bringg-frontend/eta-calculator';
import { Tooltip, ValueBar } from '@bringg/react-components';
import type { Row } from 'react-table';

import { RouteRowTranslations } from '../../../../../routes-planner/translations';
import useRunHandlingUnits from '../../../../handling-units/use-run-handling-units';
import { RoutesPlannerRun } from '../../../../../../types';
import { roundNumber } from '../../../../../../utils/numbers-utils';

interface Props {
	translations: RouteRowTranslations;
	run: RoutesPlannerRun;
	runId: number;
	tasksInventories: TaskInventory[];
	tasks: Row<RoutesPlannerTask>[];
}

const HandlingUnitsCell = ({ tasksInventories, translations, tasks, runId, run }: Props) => {
	const handlingUnits = useRunHandlingUnits({
		tasksInventories,
		tasks,
		routeId: runId,
		run
	});

	const tooltipText = [];
	let totalHandlingUnitsValue = 0;
	let totalCapacity = 0;
	let loaded = 0;
	let expected = 0;
	const { currentLoad, expectedPickup } = translations;

	handlingUnits.forEach((key, value) => {
		tooltipText.push(`${value}: ${roundNumber(key.maxValue)}`);

		totalHandlingUnitsValue += key.maxValue;
		totalCapacity += key.totalCapacity;
		loaded += key.dynamicAggregatedValues.currentLoad;
		expected = key.dynamicAggregatedValues.expectedPickup;
	});
	!isNaN(loaded) && tooltipText.push(`${currentLoad}: ${roundNumber(loaded)}`);
	!isNaN(expected) && tooltipText.push(`${expectedPickup}: ${roundNumber(expected)}`);

	return (
		<Tooltip
			key="route-row-handling-units"
			title={tooltipText.join('\n')}
			placement="top"
			overlayStyle={{ whiteSpace: 'pre-line' }}
		>
			<div>
				{totalCapacity >= 0 ? (
					<ValueBar
						value={roundNumber(totalHandlingUnitsValue)}
						total={roundNumber(totalCapacity)}
						strokeColor={'#A661E0'}
					/>
				) : (
					roundNumber(totalHandlingUnitsValue)
				)}
			</div>
		</Tooltip>
	);
};

export default HandlingUnitsCell;
